<script>
export default {
  props: {
    id: {
      type: Number,
      default: 0,
    },
    classStyle: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
      required: false,
    },
  },
  data() {
    return {
      state: false,
      class: 'container-radio',
    };
  },
  computed: {
    color() {
      return {
        '--color':process.env.VUE_APP_ORG_ID === '618183d65e84466f63c38878' ? '#FF7F50' : '#4059ff',
      };
    },
  },
  mounted() {
    this.class = this.classStyle;
  },
  methods: {
    check: function(e) {
      this.state = !this.state;
      this.state ? (this.class = 'container-radio-check') : (this.class = this.classStyle);
    },
  },
};
</script>

<template>
  <div :class="this.class" :style="colors">
    <div class="checkbox-label">
      <label for="round">{{ message }}</label>
    </div>
    <div class="round">
      <input type="checkbox" :id="id" :value="id" @change="check($event)" />
      <label :for="id"></label>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.checkbox-label {
  margin: auto;
  margin-bottom: 50px;
  font-family: $secondary-font-family;
  font-style: normal;
  font-weight: bold;
}

.container-radio {
  margin: 0 auto;
  width: 130px;
  height: 90px;
  border: 1px solid transparent;
  background: rgba(196, 196, 196, 0.2);
  padding: 16px 14px 16px 16.21px;
  border-radius: 8px;
  display: flex;
  font-weight: bold;

  .round {
    position: absolute;
  }

  .round label {
    background-color: #ffffff;
    border: 1px solid #ccc;
    border-radius: 50%;
    cursor: pointer;
    height: 18px;
    left: 55px;
    position: absolute;
    top: 71px;
    width: 18px;
  }

  .round label:after {
    border: 2px solid #fff;
    border-top: none;
    border-right: none;
    content: '';
    height: 3px;
    left: 4px;
    opacity: 0;
    position: absolute;
    top: 6px;
    transform: rotate(-45deg);
    width: 8px;
  }

  .round input[type='checkbox'] {
    visibility: hidden;
  }

  .round input[type='checkbox']:checked + label {
    background-color: var(--color) !important;
    border-color: var(--color) !important;
  }

  .round input[type='checkbox']:checked + label:after {
    opacity: 1;
  }
}

.container-radio-white {
  margin: 0 auto;
  width: 130px;
  height: 90px;
  border: 1px solid transparent;
  background: #ffffff;
  padding: 16px 14px 16px 16.21px;
  border-radius: 8px;
  display: flex;
  font-weight: bold;

  .round {
    position: absolute;
  }

  .round label {
    background-color: #ffffff;
    border: 1px solid #ccc;
    border-radius: 50%;
    cursor: pointer;
    height: 18px;
    left: 55px;
    position: absolute;
    top: 71px;
    width: 18px;
  }

  .round label:after {
    border: 2px solid #fff;
    border-top: none;
    border-right: none;
    content: '';
    height: 3px;
    left: 4px;
    opacity: 0;
    position: absolute;
    top: 6px;
    transform: rotate(-45deg);
    width: 8px;
  }

  .round input[type='checkbox'] {
    visibility: hidden;
  }

  .round input[type='checkbox']:checked + label {
    background-color: var(--color) !important;
    border-color: var(--color) !important;
  }

  .round input[type='checkbox']:checked + label:after {
    opacity: 1;
  }
}

.container-radio-check {
  margin: 0 auto;
  width: 130px;
  height: 90px;
  border: 1px solid var(--color) !important;
  background: #ffffff;
  color: var(--color) !important;
  padding: 16px 14px 16px 16.21px;
  border-radius: 8px;
  display: flex;
  font-weight: bold;

  .round {
    position: absolute;
  }

  .round label {
    background-color: var(--color) !important;
    border: 1px solid var(--color) !important;
    border-radius: 50%;
    cursor: pointer;
    height: 18px;
    left: 55px;
    position: absolute;
    top: 71px;
    width: 18px;
  }

  .round label:after {
    border: 2px solid #fff;
    border-top: none;
    border-right: none;
    content: '';
    height: 3px;
    left: 4px;
    opacity: 0;
    position: absolute;
    top: 6px;
    transform: rotate(-45deg);
    width: 8px;
  }

  .round input[type='checkbox'] {
    visibility: hidden;
  }

  .round input[type='checkbox']:checked + label {
    background-color: var(--color) !important;
    border-color: var(--color) !important;
  }

  .round input[type='checkbox']:checked + label:after {
    opacity: 1;
  }
}
</style>
